import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=14dded52&scoped=true&"
import script from "./emoji.vue?vue&type=script&setup=true&lang=ts&"
export * from "./emoji.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./emoji.vue?vue&type=style&index=0&id=14dded52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dded52",
  null
  
)

export default component.exports